import { Injectable, inject } from '@angular/core';

import { EventDataKeys, EventNames, RpFavTrackingEvents, VanillaTrackingAdapter } from '@casinocore/platform/core';

@Injectable()
export class RpFavTrackingService {
    private readonly vanillaTrackingAdapter = inject(VanillaTrackingAdapter);

    trackRpFavToggleEvent(eventDetails: string): void {
        this.vanillaTrackingAdapter.trigger({
            name: EventNames.EventTracking,
            data: {
                [EventDataKeys.ComponentCategoryEvent]: RpFavTrackingEvents.CASINOGAMES,
                [EventDataKeys.ComponentLabelEvent]: RpFavTrackingEvents.RECENTFAVOURITESTOGGLE,
                [EventDataKeys.ComponentActionEvent]: RpFavTrackingEvents.CLICK,
                [EventDataKeys.ComponentPositionEvent]: RpFavTrackingEvents.MYGAMES,
                [EventDataKeys.ComponentLocationEvent]: RpFavTrackingEvents.HOME,
                [EventDataKeys.ComponentEventDetails]: eventDetails,
            },
        });
    }
}
